import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible';
//引入公共css
import './assets/css/common.css'
//引入request文件
import {sendHttp} from './assets/js/request'

Vue.prototype.sendHttp = sendHttp
Vue.config.productionTip = false


import Bridge from '../public/iosBridge';

Vue.prototype.$bridge = Bridge;

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)


// import VConsole from 'vconsole';
// let vConsole = new VConsole();


//环境
if (process.env.NODE_ENV === 'development') {

  //测试环境
  Vue.prototype.orderUrl = 'http://order.duoduiduo.com.cn';
  Vue.prototype.accountUrl = 'http://account.duoduiduo.com.cn';
  //获取openid
  Vue.prototype.$urlPay = "http://pay.duoduiduo.com.cn/notify/getopenid";
  //图片服务器
  Vue.prototype.$upImg = "http://imageapi.duoduiduo.com.cn/file/uploadImg";
  //生产域名
  Vue.prototype.$baseUrl = "http://partner.duoduiduo.com.cn";

} else if (process.env.NODE_ENV === 'production') {
  //测试环境
  // Vue.prototype.orderUrl = 'http://order.duoduiduo.com.cn';
  // Vue.prototype.accountUrl = 'http://account.duoduiduo.com.cn';
  // //获取openid
  // Vue.prototype.$urlPay = "http://pay.duoduiduo.com.cn/notify/getopenid";
  // //图片服务器
  // Vue.prototype.$upImg = "http://imageapi.duoduiduo.com.cn/file/uploadImg";
  // //生产域名
  // Vue.prototype.$baseUrl = "http://partner.duoduiduo.com.cn";

  //生产环境
  Vue.prototype.orderUrl = 'https://order.duoduiduo.com';
  Vue.prototype.accountUrl = 'https://account.duoduiduo.com';
  //获取openid
  Vue.prototype.$urlPay = "https://pay.duoduiduo.com/notify/getopenid";
  //图片服务器
  Vue.prototype.$upImg = "https://imageapi.duoduiduo.com/file/uploadImg";
  //生产域名
  Vue.prototype.$baseUrl = "https://partner.duoduiduo.com";
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
